"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var attributes_1 = require("./attributes");
var specialElementHandlers_1 = require("./specialElementHandlers");
var mapAttributeToReact = function (attributeName) {
    return attributes_1.nameMap[attributeName.toLowerCase()] || attributeName.toLowerCase();
};
var makeRefStyleHandler = function (styleString) {
    return function (ref) {
        if (ref !== null) {
            ref.setAttribute("style", styleString);
        }
    };
};
var bootstrapStyles = function (attributes) { return (__assign({}, attributes, { ref: makeRefStyleHandler(attributes.style), style: undefined })); };
exports.default = (function (el, recursor) { return __awaiter(_this, void 0, void 0, function () {
    var tagName, attributes, handler, children;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                tagName = el.tagName.toLowerCase();
                attributes = {};
                if (el.hasAttributes()) {
                    attributes = Array.from(el.attributes)
                        .map(function (_a) {
                        var name = _a.name, value = _a.value;
                        if (attributes_1.boolean.includes(name) && value === "") {
                            // React, and JavaScript, view "" as falsy. However, an empty string on
                            // a DOM element's attribute makes it truthy. This compensates for the
                            // discrepancy.
                            return { name: name, value: true };
                        }
                        return { name: name, value: value };
                    })
                        .reduce(function (acc, _a) {
                        var name = _a.name, value = _a.value;
                        var _b;
                        return (__assign({}, acc, (_b = {}, _b[mapAttributeToReact(name)] = value, _b)));
                    }, {});
                    if ("style" in attributes) {
                        attributes = bootstrapStyles(attributes);
                    }
                    handler = specialElementHandlers_1.default[tagName];
                    if (handler) {
                        attributes = handler(el, attributes);
                    }
                }
                if (!(tagName !== "textarea" && el.childNodes)) return [3 /*break*/, 2];
                return [4 /*yield*/, Promise.all(Array.from(el.childNodes).map(recursor))];
            case 1:
                children = _a.sent();
                return [2 /*return*/, React.createElement.apply(React, [tagName, attributes].concat(children))];
            case 2: return [2 /*return*/, React.createElement(tagName, attributes)];
        }
    });
}); });
//# sourceMappingURL=staticToReactElement.js.map